import {_} from 'lodash';
import * as ko from "knockout";
import {IButton, IKnockoutComponent, TBaseOrObservableType} from "../index";
import {getAnyValue, getEadmRole} from "./misc";
import {Permission} from "../constants";
import {ISplitButtonParams} from "@component/button/splitButton/split-button";
import {nsRoute} from "./route";
import ButtonOrder = nsRoute.ButtonOrder;

export class ButtonManager {
    buttons!: KnockoutObservableArray<TBaseOrObservableType<IButton> | TBaseOrObservableType<IKnockoutComponent> | TBaseOrObservableType<ISplitButtonParams>>;

    constructor(private arr: IButton[] | KnockoutObservableArray<IButton> = []) {
        this.init()
    }

    init() {
        if (ko.isObservable(this.arr)) {
            this.buttons = this.arr as typeof this.buttons;
        } else {
            this.buttons = ko.observableArray(this.arr) as typeof this.buttons;
        }
    }

    add(btnOrComp: TBaseOrObservableType<IButton> | ISplitButtonParams | null | undefined) {
        if (!btnOrComp) {
            return
        }
        let btn = btnOrComp as TBaseOrObservableType<IButton>
        if ('mainButton' in btnOrComp) {
            btn = {
                order: ButtonOrder.SPLIT_BUTTON,
                getComponent: () => ({
                    name: 'component/button/splitButton/split-button',
                    params: btnOrComp,
                }),
            }
        }
        this.addButton(btn)
    }

    private addButton(btn: TBaseOrObservableType<IButton>) {
        const b1 = getAnyValue(btn)
        const exists = this.buttons().find((_btn) => {
            const b2 = getAnyValue(_btn) as IButton
            if ('label' in b2) {
                const l1 = getAnyValue(b1.label)
                const l2 = getAnyValue(b2.label)
                return l1 == l2
            }
            if ('description' in b2) {
                return getAnyValue(b1.description) == getAnyValue(b2.description)
            }
            return false
        });
        if (!exists) {
            this.buttons.push(btn);
        }
    }

    remove(btn: IButton) {
        const index = this.buttons().findIndex(_btn => _.isMatch(_btn, btn));
        this.buttons.splice(index, 1);
    }

    sorted = ko.pureComputed((): IButton[] => {
        return _(this.buttons())
            .map((btn: TBaseOrObservableType<IButton> | TBaseOrObservableType<IKnockoutComponent> | TBaseOrObservableType<ISplitButtonParams>) => getAnyValue(btn) as IButton)
            .filter(Boolean)
            .filter((btn: IButton) => btn.validator?.() ?? (btn.permissionLevel ?? Permission.None) <= getEadmRole())
            .sortBy((btn: IButton) => btn.order ?? 0)
            .value()
    })

}